// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"SlotContent_contentWrapper__1n6PS","label":"SlotContent_label__2uTmi","value":"SlotContent_value__2xZIB","wrappedContent":"SlotContent_wrappedContent__2Hl2O"};